var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgUnlocked = function SvgUnlocked(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.55556 11.0998V7.50071C7.55445 6.38504 7.96292 5.30874 8.70167 4.48077C9.44041 3.6528 10.4567 3.13223 11.5533 3.0201C12.6499 2.90798 13.7486 3.21231 14.636 3.87401C15.5234 4.53571 16.1362 5.50758 16.3556 6.60094M5.77778 11.0998H18.2222C19.2041 11.0998 20 11.9055 20 12.8994V19.1978C20 20.1916 19.2041 20.9973 18.2222 20.9973H5.77778C4.79594 20.9973 4 20.1916 4 19.1978V12.8994C4 11.9055 4.79594 11.0998 5.77778 11.0998Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgUnlocked);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "unlocked.fceadaf1032718ad877102a2df0ef5d0.svg";